/* Paw & Cove / MediaGo Kaching add-to-cart bridge.
 * Analytics only: observes a successful Kaching cart change after an add click,
 * then reports one MediaGo conversion. It never changes cart writes, product
 * quantity, Kaching configuration, pricing, checkout, or payment.
 */
(() => {
  'use strict';

  if (window.__pawMediaGoCartBridge || window.Shopify?.shop !== 't7jqd4-ie.myshopify.com') return;
  const state = window.__pawMediaGoCartBridge = {
    version: 2,
    sent: 0,
    pending: false,
  };

  const mediaGoEvent = {
    type: 'event',
    name: '宠物-加入购物车',
    acid: '36948',
    pxd: '1739099930558024',
  };

  const addSelector = [
    'button[name="add"]',
    '[id^="SectionAtcBtn-"]',
    'product-form button[type="submit"]',
    'form[action*="/cart/add"] button[type="submit"]',
  ].join(',');
  let baseline = null;
  let refreshTimer;

  const consentAllowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return false;
    return privacy.analyticsProcessingAllowed?.() === true
      && privacy.marketingAllowed?.() === true
      && privacy.saleOfDataAllowed?.() === true;
  };

  const loadMediaGo = () => {
    window._megoaa = window._megoaa || [];
    window._megoaa.push({...mediaGoEvent});

    const scriptId = 'pixel_megoaa_script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.async = true;
      script.src = 'https://cdn.mediago.io/js/pixel.js?acid=36948';
      (document.head || document.body || document.documentElement).appendChild(script);
    }
  };

  const readCart = async () => {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {'Accept': 'application/json'},
    });
    if (!response.ok) throw new Error('Cart read unavailable');
    return response.json();
  };

  const quantityByVariant = cart => {
    const totals = new Map();
    for (const line of cart?.items || []) {
      const id = String(line.variant_id || line.id || '');
      if (!id) continue;
      totals.set(id, (totals.get(id) || 0) + Number(line.quantity || 0));
    }
    return totals;
  };

  const addedLines = (before, after) => {
    const oldTotals = quantityByVariant(before);
    const result = [];
    for (const line of after?.items || []) {
      const id = String(line.variant_id || line.id || '');
      const current = Number(line.quantity || 0);
      const added = Math.max(0, current - (oldTotals.get(id) || 0));
      oldTotals.delete(id);
      if (!added) continue;
      result.push({
        variantId: id,
        quantity: added,
        valueCents: current > 0 ? Math.round(Number(line.final_line_price || 0) * added / current) : 0,
      });
    }
    return result;
  };

  const refreshBaseline = delay => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      readCart().then(cart => { baseline = cart; }).catch(() => {});
    }, delay);
  };

  async function verifyAdd(actionId, before) {
    const startedAt = Date.now();
    try {
      while (Date.now() - startedAt < 12000) {
        await new Promise(resolve => setTimeout(resolve, 350));
        const after = await readCart();
        const added = addedLines(before, after);
        if (!added.length) continue;

        if (!consentAllowed()) {
          state.lastSkip = 'consent_not_allowed';
          baseline = after;
          return;
        }

        loadMediaGo();
        state.sent += 1;
        state.lastActionId = actionId;
        state.lastAddedQuantity = added.reduce((sum, line) => sum + line.quantity, 0);
        state.lastValue = added.reduce((sum, line) => sum + line.valueCents, 0) / 100;
        baseline = after;
        return;
      }
    } catch {
      // Tracking must never affect a customer's cart action.
    } finally {
      state.pending = false;
      refreshBaseline(0);
    }
  }

  document.addEventListener('click', event => {
    const button = event.target?.closest?.(addSelector);
    // The standard Shopify event remains responsible for ordinary product
    // forms and later cart quantity changes. This bridge is deliberately
    // limited to Kaching's initial bundle add, which omits that event.
    if (!button || button.disabled || state.pending || !baseline || !document.querySelector('kaching-bundles-block')) return;
    state.pending = true;
    const actionId = typeof crypto?.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    verifyAdd(actionId, baseline);
  }, true);

  // Keep the baseline current after ordinary cart quantity/removal controls.
  document.addEventListener('click', event => {
    if (event.target?.closest?.('quantity-input, cart-remove-button, [data-cart-remove], [name="updates[]"]')) {
      refreshBaseline(900);
    }
  }, true);
  document.addEventListener('change', event => {
    if (event.target?.matches?.('[name="updates[]"], quantity-input input')) refreshBaseline(900);
  }, true);

  const start = () => refreshBaseline(0);
  if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], start);
  } else {
    start();
  }
})();
